import type { SVGProps } from 'react';

export function GhostIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m6.304 19.916-.42.338a.669.669 0 0 1-1.084-.521V9.6c0-3.975 3.225-7.2 7.2-7.2s7.2 3.225 7.2 7.2v10.132a.669.669 0 0 1-1.084.522l-.42-.338a1.2 1.2 0 0 0-1.654.146L14.9 21.375a.662.662 0 0 1-.998 0l-.997-1.144a1.2 1.2 0 0 0-1.808 0l-.997 1.144a.662.662 0 0 1-.998 0l-1.144-1.313a1.2 1.2 0 0 0-1.653-.146M10.8 9.6c0-.664-.536-1.2-1.2-1.2s-1.2.536-1.2 1.2.536 1.2 1.2 1.2 1.2-.536 1.2-1.2m3.6 1.2c.664 0 1.2-.536 1.2-1.2s-.536-1.2-1.2-1.2-1.2.536-1.2 1.2.536 1.2 1.2 1.2" />
    </svg>
  );
}
